import { joinCn } from '../util';
import type { VLabelProps } from './type';

const style = {
  vLabel({
    required,
    disabled,
  }: {
    required: VLabelProps['required'];
    disabled?: VLabelProps['disabled'];
  }) {
    return joinCn(
      'relative flex w-fit items-center text-body-sm capitalize select-none',
      disabled ? ['!text-gray-400'] : ['text-gray-600'],
      required
        ? [
            'after:absolute  after:top-0 after:-right-2',
            'after:h-1 after:w-1',
            'after:bg-error-500',
            'after:rounded-full',
            'after:content-[""]',
          ]
        : [],
    );
  },
};

export default style;
